// extracted by mini-css-extract-plugin
export default {"no_match":"VerifyEmailPage_no_match__Sd8Xj"};